var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsTrashAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.97381 11.7606H8.807C9.38975 11.7606 9.864 11.2863 9.864 10.7036V3.59375H11.0312V2.64569H8.69806V1.36994C8.69806 0.78675 8.22381 0.3125 7.64062 0.3125H4.14062C3.55744 0.3125 3.08319 0.78675 3.08319 1.36994V2.64612H0.75V3.59375H1.91681V10.7031C1.91681 11.2863 2.39106 11.7606 2.97381 11.7606ZM4.03125 1.26056H7.75V2.64612H4.03125V1.26056ZM2.86444 3.59375H8.91637L8.91725 10.8125H2.86444V3.59375Z",
    fill: "#FAFBFA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.53107 4.97925H6.58301V9.42731H7.53107V4.97925Z",
    fill: "#FAFBFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.19806 4.97925H4.25V9.42731H5.19806V4.97925Z",
    fill: "#FAFBFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsTrashAlt);
export default __webpack_public_path__ + "static/media/icons-trash-alt.71c369aa1315fcc69e5806302d50d704.svg";
export { ForwardRef as ReactComponent };